// @flow

export const COMPANY_CONTACTS_UPDATE_PHONES = 'COMPANY_CONTACTS_UPDATE_PHONES'
